// Bridges ui.ts's cast handler to GameScene for a Separate·Charge cast --
// cuts an existing Bind·Charge link (see chargeBindEffect.ts). Bind strings
// the wire, Separate cuts it, the same create/undo shape the operator pair
// already has for Momentum, Energy and Mass.
//
// The event/result shapes themselves live in rune-lab/src/sim/casts.ts with the
// handler that consumes them, and are re-exported here unchanged, so every
// import site reads them from this module -- the same shape every other
// operator effect's bridge already has.
import { UnbindChargeEffectEvent, UnbindChargeEffectResult } from '../../rune-lab/src/sim/casts';

export type { UnbindChargeEffectEvent, UnbindChargeEffectResult };

type Handler = (event: UnbindChargeEffectEvent) => UnbindChargeEffectResult;

let handler: Handler | null = null;

export function onUnbindChargeEffect(fn: Handler): void {
  handler = fn;
}

export function triggerUnbindChargeEffect(event: UnbindChargeEffectEvent): UnbindChargeEffectResult {
  return handler ? handler(event) : { applied: false, targetName: '' };
}
